import React from 'react';
import 'lib/comments-common/styles/global.css';
import 'lib/comments-common/styles/dark-theme.css';
import ApiStatusManager from './ApiStatusManager';
import AddCommentContainer from './AddCommentContainer';
import CommentListContainer from './CommentListContainer';

function RoadmapComments() {
  return (
    <>
      <ApiStatusManager />
      <AddCommentContainer />
    </>
  );
}

export function CommentListOnly() {
  return <CommentListContainer />;
}

export default RoadmapComments;
